var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.themeSwitcher
      ? _c("div", { staticClass: "settings-holder" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("Account.AppSettings.Theme")))]),
          _vm._v(" "),
          _c("div", { staticClass: "options_holder" }, [
            _c(
              "div",
              {
                staticClass: "radio-item light",
                class: { disabled: _vm.mobileThemeAutomaticVal }
              },
              [
                _c("label", { attrs: { for: "light" } }, [
                  _vm._v(_vm._s(_vm.$t("Account.AppSettings.Theme.Light"))),
                  _c("div", {
                    staticClass: "radio_btn",
                    class: {
                      selected:
                        _vm.selectedThemeVal === "light" &&
                        !_vm.mobileThemeAutomaticVal
                    }
                  })
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedThemeVal,
                      expression: "selectedThemeVal"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "light",
                    value: "light",
                    disabled: _vm.mobileThemeAutomaticVal
                  },
                  domProps: { checked: _vm._q(_vm.selectedThemeVal, "light") },
                  on: {
                    change: [
                      function($event) {
                        _vm.selectedThemeVal = "light"
                      },
                      function($event) {
                        return _vm.changeTheme("light")
                      }
                    ]
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "radio-item dark",
                class: { disabled: _vm.mobileThemeAutomaticVal }
              },
              [
                _c("label", { attrs: { for: "dark" } }, [
                  _vm._v(_vm._s(_vm.$t("Account.AppSettings.Theme.Dark"))),
                  _c("div", {
                    staticClass: "radio_btn",
                    class: {
                      selected:
                        _vm.selectedThemeVal === "dark" &&
                        !_vm.mobileThemeAutomaticVal
                    }
                  })
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedThemeVal,
                      expression: "selectedThemeVal"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "dark",
                    value: "dark",
                    disabled: _vm.mobileThemeAutomaticVal
                  },
                  domProps: { checked: _vm._q(_vm.selectedThemeVal, "dark") },
                  on: {
                    change: [
                      function($event) {
                        _vm.selectedThemeVal = "dark"
                      },
                      function($event) {
                        return _vm.changeTheme("dark")
                      }
                    ]
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _vm.isMobileApp
            ? _c(
                "div",
                { staticClass: "auto" },
                [
                  _c("v-switch", {
                    attrs: {
                      val: _vm.mobileThemeAutomaticVal,
                      label: _vm.$t("Account.AppSettings.Theme.Automatic")
                    },
                    on: {
                      change: function($event) {
                        return _vm.changeThemeAutomatic(
                          _vm.mobileThemeAutomaticVal
                        )
                      }
                    },
                    model: {
                      value: _vm.mobileThemeAutomaticVal,
                      callback: function($$v) {
                        _vm.mobileThemeAutomaticVal = $$v
                      },
                      expression: "mobileThemeAutomaticVal"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.supportedLocale.length > 1
      ? _c(
          "div",
          { staticClass: "settings-holder" },
          [
            _c("h1", [_vm._v(_vm._s(_vm.$t("Account.AppSettings.Language")))]),
            _vm._v(" "),
            _c("language-switcher", {
              staticClass: "popular expand navigation mainmenu",
              attrs: { id: "lang" }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b675530", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b675530","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppSettings.vue
// module id = null
// module chunks = 